import React from 'react';
import { PreviewContent } from '../../../../styles/TradeDocStyles';
import { Stack } from '@mui/material';
import moment from 'moment';
import DocumentViewer from '../../../DocumentViewer/DocumentViewer';
import { REACT_APP_BASE_URL } from '../../../../config';
import { formatNumber } from '../../../../utils/helper';
import { SalesContractPayload } from '../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/SslesContracyInterface';
import { TransformedItems } from '../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';

const MobileSalesContractPreview = ({
    data,
    docTitle,
    quoteFields,
    signatureUrlBase64Exporter
}: {
    data: SalesContractPayload;
    docTitle: string;
    quoteFields: TransformedItems[];
    signatureUrlBase64Exporter?: string;
}) => {
    return (
        <PreviewContent style={{ padding: '25px 0' }}>
            <div className='flex items-center justify-between pb-4 mb-4'>
                <div>
                    <img
                        src='/img/vectors/powered.svg'
                        alt=''
                        className='h-[2.5rem]'
                    />
                </div>
            </div>

            <Stack
                direction='column'
                alignItems='start'
                className='top-preview-content space-y-4'
                width='full'
                justifyContent={'space-between'}
            >
                <div className='view-one' style={{ maxWidth: '100%' }}>
                    <p className='font-semibold text-appcolorprimary'>Buyer</p>
                    <p className='font-medium'>{data?.customerName ?? '--'}</p>
                    <p>{data?.buyerAddress ?? '--'}</p>
                </div>

                <div className='view-two' style={{ maxWidth: '100%' }}>
                    <p className='font-semibold text-appcolorprimary'>
                        Exporter
                    </p>
                    <p className='font-medium'>{data?.exporterName ?? '--'}</p>
                    <p>{data?.exporterAddress ?? '--'}</p>
                </div>

                <div
                    className='view-three space-y-2 border-t pt-4'
                    style={{ maxWidth: '100%' }}
                >
                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                        style={{ marginBottom: 0 }}
                    >
                        <p className='title'>Contract No.</p>
                        <p className='value'>{data?.contractNumber || '--'}</p>
                    </Stack>
                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                    >
                        <p className='title'>Contract Type.</p>
                        <p className='value'>{data?.contractType || '--'}</p>
                    </Stack>
                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                    >
                        <p className='title'>Payment Terms</p>
                        <p className='value'>{data?.paymentTerms || '--'}</p>
                    </Stack>
                    <Stack
                        direction='row'
                        gap='20px'
                        width='100%'
                        justifyContent='space-between'
                    >
                        <p className='title'>Shipping Deadline</p>
                        <p className='value'>
                            {moment(data.shippingDeadline).format('ll') || '--'}
                        </p>
                    </Stack>
                </div>
            </Stack>

            <Stack
                direction='column'
                alignItems='start'
                className='mid-preview-content border-b pb-4'
                width='full'
                justifyContent={'space-between'}
                style={{ borderTop: '1px solid #e5e7eb', marginBottom: 0 }}
            >
                <div className='view-one' style={{ maxWidth: '100%' }}>
                    <div className='flex justify-between'>
                        <p className='title'>Container Type</p>
                        <p className='value'>{data?.containerType || '--'}</p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>Port of Dispatch</p>
                        <p className='value'>
                            {data?.portOfDischargeValue?.toDisplay ?? '--'}
                        </p>
                    </div>
                </div>

                <div className='view-one' style={{ maxWidth: '100%' }}>
                    <div className='flex justify-between'>
                        <p className='title'>Port of Loading</p>
                        <p className='value'>
                            {data?.portOfLoadingValue?.toDisplay || '--'}
                        </p>
                    </div>
                    <div className='flex justify-between'>
                        <p className='title'>Shipping Lines</p>
                        <p className='value'>
                            {data?.shippingLineValue || '--'}
                        </p>
                    </div>
                </div>
            </Stack>

            {quoteFields?.map((item: any) => (
                <Stack
                    direction='column'
                    alignItems='start'
                    className='mid-preview-content mt-0 border-b border-dashed bg-aliceBlue p-2'
                    width='full'
                    justifyContent={'space-between'}
                    style={{
                        marginBottom: 0,
                        marginTop: 0,
                        borderStyle: 'dashed'
                    }}
                >
                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <div className='flex justify-between'>
                            <p className='title'>Commodity</p>
                            <p className='value'>{item.commodity ?? '--'}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Commodity Type</p>
                            <p className='value'>
                                {item.commodityType ?? '--'}
                            </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Quality </p>
                            <p className='value'>{item.quality ?? '--'} </p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Quantity</p>
                            <p className='value'>
                                {formatNumber(item.quantity ?? 0)}
                            </p>{' '}
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Unit Metric</p>
                            <p className='value'>{item.metric ?? '--'}</p>
                        </div>
                        <div className='flex justify-between'>
                            <p className='title'>Quantity Buffer </p>
                            <p className='value'>
                                {item.quantityBuffer ?? '--'}%{' '}
                            </p>
                        </div>
                    </div>
                </Stack>
            ))}

            <Stack
                direction='row'
                alignItems='start'
                className='sales-info-preview-content mt-2'
                width='full'
                justifyContent={'space-between'}
            >
                {data?.additionalInfo && (
                    <div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: data?.additionalInfo
                            }}
                        />
                    </div>
                )}
            </Stack>

            <Stack
                direction='column'
                alignItems='start'
                className='bottom-preview-content'
                width='full'
                justifyContent={'space-between'}
                style={{
                    position: 'static',
                    marginTop: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }}
            >
                <div
                    className='view-one space-y-2'
                    style={{ maxWidth: '100%' }}
                >
                    {data?.stamp && (
                        <Stack direction='row' justifyContent='flex-end'>
                            <div className='totalView w-[250px]'>
                                <p className='titl'>Exporter Stamp</p>
                                <div className='h-[50px]'>
                                    <DocumentViewer
                                        fileUrl={`${REACT_APP_BASE_URL}/${data?.stamp.split(
                                            '/v1/'
                                        )[1]}`}
                                    />
                                </div>
                            </div>
                        </Stack>
                    )}
                </div>

                <div
                    className='view-two space-y-2 mt-2'
                    style={{ maxWidth: '100%' }}
                >
                    <div>
                        {' '}
                        <p className='titl'>Exporter Signature</p>
                        <img src={`${signatureUrlBase64Exporter}`} alt='' />
                    </div>
                </div>
            </Stack>
        </PreviewContent>
    );
};

export default MobileSalesContractPreview;
